
import {
  Options,
  Vue
} from 'vue-class-component'
// import { h } from 'vue'
import * as API from '@/server'
import * as tools from '@/assets/tools'
import * as store from '../store'
import { 
  NSpace,
  NAvatar,
  NText
 } from 'naive-ui'
@Options({
  components: {
    NAvatar,
    NSpace,
    NText
  }
})
export default class NavView extends Vue {
  public test = 1
  public user: any = {}
  public isShowLogout = false
  public isFromAgency = false
  showLogout () {
    this.isShowLogout = true
  }
  logout () {
    tools.logout()
    API.logOut()
  }
  goIndex () {
    window.location.href = 'https://www.woolive.tv/'
  }
  created () {
    store.Watch('user', (nk) => {
      this.user = nk
    })
    store.Watch('isFromAgency', (nk) => {
      this.isFromAgency = nk
    })
  }
}
